import React from 'react';
import styled from 'styled-components';
import CloseButton from 'common-modules/general/assets/Desktop/images/common/ico_close02.png';

const BackgroundContainer = styled.div<{ width: number; height: number }>`
  position: fixed;
  z-index: 9999999;
  top: 0px;
  left: 0px;
  width: 990px;
  background-color: #1b1b1b;
  width: ${props => props.width}px;
  height: ${props => props.height}px;
  padding: 5rem 2rem;
  box-sizing: border-box;
`;

const CloseIcon = styled.img`
  position: absolute;
  right: 120px;
  top: 20px;
  float: right;
  display: inline-block;
  margin-top: 10px;
  cursor: position;
  cursor: pointer;
`;

interface Props {
  url: string;

  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const MoviePopup = ({ url, open, setOpen }: Props) => {
  const width = window.innerWidth;
  const height = window.innerHeight;

  return open ? (
    <BackgroundContainer width={width} height={height}>
      <iframe src={url} width={`100%`} height={`100%`} title="사이버 주택 전시관" allowFullScreen allow="autoplay" />
      <CloseIcon onClick={() => setOpen(false)} src={CloseButton} />
    </BackgroundContainer>
  ) : null;
};

export default MoviePopup;
